import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img24 from "../../About/images/24.webp";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person24 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img24} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Шимпф Алексей Андреевич
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Automation and Control, Master of technical sciences
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-4203-9117'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        НАО "Toraighyrov University", заведующий учебной лабораторией кафедры «Электротехника и Автоматизация»
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Обзор литературы для подготовки научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на основных стационарных источниках эмиссий ответственным в области охраны окружающей среды.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Магистр технических наук по специальности «Автоматизация и управление». Тема диссертации: «Разработка лабораторного стенда и методического обеспечения по исследованию системы автоматизированного контроля теплотехнических параметров». Обладает навыками работы в MatLab+Simulink, AutoCAD, знаниями в сфере автоматизации, электротехники и математического моделирования.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Программно-целевой проект BR21882258 (2023–2025): «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий». Роль – исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Обзор литературы для подготовки научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на основных стационарных источниках эмиссий ответственным в области охраны окружающей среды.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Zhalmagambetova U., Neftisov A., Shimpf A., Kislov A., Krykbayeva M. Designing information transmission systems for automated environmental monitoring. Торайғыров университетінің хабаршысы. Энергетикалық сериясы. №1, 2025. С. 108–120. DOI: 10.48081/WNUU3720 (КОКСОН МНиВО РК)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Kirichenko L.N., Zhalmagambetova U.K., Krykbayeva M.S., Komandirov E.V., Shimpf A.A. Methods for determining emissions from major stationary sources of pollution. Торайғыров университетінің хабаршысы. Энергетикалық сериясы. №3, 2024. С. 167–182. DOI: 10.48081/HRWJ4394 (КОКСОН МНиВО РК)
                </MyText>
            </Flex>
        </Flex>
    );
}